<h3>
    <a ng-click="viewDetails($event, item)">
        <i ng-if="item.checkedOut !== null" class="fa fa-pencil checkedOut"></i>
        {{ item.name }}
    </a>
</h3>
<div style="padding: 5px 0 0 0">
    {{ item.description }}
</div>
